import { render, staticRenderFns } from "./exercises-list.vue?vue&type=template&id=468651b2"
import script from "./exercises-list.vue?vue&type=script&lang=js"
export * from "./exercises-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports